@if (userProcess && personalDataForm) {
  <div
    class="stepper-container"
    [class.with-bottom-action-bar]="mode === 'foreigner' && !bottomActionBarInFlow"
    #stepperContainer>
    <mat-stepper
      orientation="vertical"
      [linear]="false"
      [disableRipple]="true"
      (animationDone)="stepAnimationDone()"
      [animationDuration]="deviceInfo?.deviceTypeDetected === 'DESKTOP' ? (mode === 'foreigner' ? '450' : '300') : '0'"
      [attr.aria-label]="'COMMON.LAYOUT.USER_DETAILS' | translate"
      #mainStepper>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="warn" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <!-- STEP 1 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step1']"
        [completed]="personalDataForm.controls['step1'].valid"
        [state]="
          mainStepper.selectedIndex === 0
            ? 'edit'
            : personalDataForm.controls['step1'].touched && personalDataForm.controls['step1'].valid
              ? 'done'
              : personalDataForm.controls['step1'].touched && personalDataForm.controls['step1'].invalid
                ? 'warn'
                : personalDataForm.controls['step1'].pristine && personalDataForm.controls['step1'].invalid
                  ? 'number'
                  : personalDataForm.controls['step1'].pristine && personalDataForm.controls['step1'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step1-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 0 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step1-label">{{ 'PERSONAL_DATA_FORM.PERSONAL-DATA' | translate }}</span>
          <button
            type="button"
            class="guide-open-button"
            mat-icon-button
            tabindex="-1"
            aria-hidden="true"
            (click)="initGuide(GUIDE_NAME.PERSONAL_DATA_FORM, 1)"
            [attr.aria-label]="'GUIDE.SHOW_INSTRUCTIONS' | translate"
            matTooltip="{{ 'GUIDE.SHOW_INSTRUCTIONS' | translate }}"
            matTooltipClass="universalTooltip"
            matTooltipPosition="right">
            <mat-icon fontSet="material-icons-outlined"> live_help </mat-icon>
          </button>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step1
            [formGroup]="personalDataForm.controls['step1']"
            [mode]="mode"
            (lastFieldTabPressed)="mainStepper.next()">
          </app-perm-stay-step1>
        </ng-template>
      </mat-step>
      <!-- STEP 2 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step2']"
        [completed]="personalDataForm.controls['step2'].valid"
        [state]="
          mainStepper.selectedIndex === 1
            ? 'edit'
            : personalDataForm.controls['step2'].touched && personalDataForm.controls['step2'].valid
              ? 'done'
              : personalDataForm.controls['step2'].touched && personalDataForm.controls['step2'].invalid
                ? 'warn'
                : personalDataForm.controls['step2'].pristine && personalDataForm.controls['step2'].invalid
                  ? 'number'
                  : personalDataForm.controls['step2'].pristine && personalDataForm.controls['step2'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step2-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 1 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step2-label">{{ 'PERSONAL_DATA_FORM.PERSONAL-DETAILS' | translate }}</span>
          <button
            type="button"
            class="guide-open-button"
            mat-icon-button
            tabindex="-1"
            aria-hidden="true"
            (click)="initGuide(GUIDE_NAME.FORM_STEP_2, 2)"
            [attr.aria-label]="'GUIDE.SHOW_INSTRUCTIONS' | translate"
            matTooltip="{{ 'GUIDE.SHOW_INSTRUCTIONS' | translate }}"
            matTooltipClass="universalTooltip"
            matTooltipPosition="right">
            <mat-icon fontSet="material-icons-outlined"> live_help </mat-icon>
          </button>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step2
            [formGroup]="personalDataForm.controls['step2']"
            [userProcess]="userProcess"
            [mode]="mode"
            (firstInputShiftTabPressed)="mainStepper.previous()"
            (lastFieldTabPressed)="mainStepper.next()"
            (confirmVoivoChange)="confirmVoivoChange.emit()">
          </app-perm-stay-step2>
        </ng-template>
      </mat-step>
      <!-- STEP 3 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step3']"
        [completed]="personalDataForm.controls['step3'].valid"
        [state]="
          mainStepper.selectedIndex === 2
            ? 'edit'
            : personalDataForm.controls['step3'].touched && personalDataForm.controls['step3'].valid
              ? 'done'
              : personalDataForm.controls['step3'].touched && personalDataForm.controls['step3'].invalid
                ? 'warn'
                : personalDataForm.controls['step3'].pristine && personalDataForm.controls['step3'].invalid
                  ? 'number'
                  : personalDataForm.controls['step3'].pristine && personalDataForm.controls['step3'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step3-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 2 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step3-label">{{ 'PERSONAL_DATA_FORM.STATEMENTS' | translate }}</span>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step3
            [formGroup]="personalDataForm.controls['step3']"
            [mode]="mode"
            [maritalStatus]="userProcess.personalDetails.maritalStatus"
            (firstInputShiftTabPressed)="mainStepper.previous()"
            (lastFieldTabPressed)="mainStepper.next()">
          </app-perm-stay-step3>
        </ng-template>
      </mat-step>
      <!-- STEP 4 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step4']"
        [completed]="personalDataForm.controls['step4'].valid"
        [state]="
          mainStepper.selectedIndex === 3
            ? 'edit'
            : personalDataForm.controls['step4'].touched && personalDataForm.controls['step4'].valid
              ? 'done'
              : personalDataForm.controls['step4'].touched && personalDataForm.controls['step4'].invalid
                ? 'warn'
                : personalDataForm.controls['step4'].pristine && personalDataForm.controls['step4'].invalid
                  ? 'number'
                  : personalDataForm.controls['step4'].pristine && personalDataForm.controls['step4'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step4-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 3 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step4-label">{{ 'PERSONAL_DATA_FORM.TRAVELS-AND-STAYS' | translate }}</span>
          <button
            type="button"
            class="guide-open-button"
            mat-icon-button
            tabindex="-1"
            aria-hidden="true"
            (click)="initGuide(GUIDE_NAME.FORM_STEP_4, 4)"
            [attr.aria-label]="'GUIDE.SHOW_INSTRUCTIONS' | translate"
            matTooltip="{{ 'GUIDE.SHOW_INSTRUCTIONS' | translate }}"
            matTooltipClass="universalTooltip"
            matTooltipPosition="right">
            <mat-icon fontSet="material-icons-outlined"> live_help </mat-icon>
          </button>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step4
            [formGroup]="personalDataForm.controls['step4']"
            [mode]="mode"
            [userProcess]="userProcess"
            (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit()"
            (firstInputShiftTabPressed)="mainStepper.previous()"
            (lastFieldTabPressed)="mainStepper.next()">
          </app-perm-stay-step4>
        </ng-template>
      </mat-step>
      <!-- STEP 5 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step5']"
        [completed]="personalDataForm.controls['step5'].valid"
        [state]="
          mainStepper.selectedIndex === 4
            ? 'edit'
            : personalDataForm.controls['step5'].touched && personalDataForm.controls['step5'].valid
              ? 'done'
              : personalDataForm.controls['step5'].touched && personalDataForm.controls['step5'].invalid
                ? 'warn'
                : personalDataForm.controls['step5'].pristine && personalDataForm.controls['step5'].invalid
                  ? 'number'
                  : personalDataForm.controls['step5'].pristine && personalDataForm.controls['step5'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step5-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 4 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step5-label">{{ 'PERSONAL_DATA_FORM.FAMILY-MEMBERS-LIVING-IN-POLAND' | translate }}</span>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step5
            [formGroup]="personalDataForm.controls['step5']"
            [mode]="mode"
            [userProcess]="userProcess"
            (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit()"
            (firstInputShiftTabPressed)="mainStepper.previous()"
            (lastFieldTabPressed)="mainStepper.next()">
          </app-perm-stay-step5>
        </ng-template>
      </mat-step>
      <!-- STEP 6 -->
      <mat-step
        [stepControl]="personalDataForm.controls['step6']"
        [completed]="personalDataForm.controls['step6'].valid"
        [state]="
          mainStepper.selectedIndex === 5
            ? 'edit'
            : personalDataForm.controls['step6'].touched && personalDataForm.controls['step6'].valid
              ? 'done'
              : personalDataForm.controls['step6'].touched && personalDataForm.controls['step6'].invalid
                ? 'warn'
                : personalDataForm.controls['step6'].pristine && personalDataForm.controls['step6'].invalid
                  ? 'number'
                  : personalDataForm.controls['step6'].pristine && personalDataForm.controls['step6'].valid
                    ? 'done'
                    : 'number'
        "
        tabindex="-1"
        [attr.aria-labelledby]="'step6-label'"
        [attr.aria-current]="mainStepper.selectedIndex === 5 ? 'step' : null">
        <ng-template matStepLabel>
          <span id="step6-label">{{
            'PERSONAL_DATA_FORM.JUSTIFICATION-FOR-THE-APPLICATION.MAIN-LABEL' | translate
          }}</span>
        </ng-template>
        <ng-template matStepContent>
          <app-perm-stay-step6
            [formGroup]="personalDataForm.controls['step6']"
            [mode]="mode"
            [userProcess]="userProcess"
            (firstInputShiftTabPressed)="mainStepper.previous()"
            (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit()"
            (lastFieldTabPressed)="saveAndProceedButton.focus()">
          </app-perm-stay-step6>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </div>
}
@if (mode === 'foreigner') {
  <div class="save-and-proceed-container" [class.in-flow]="bottomActionBarInFlow">
    @if (personalDataForm) {
      <div class="overall-controls">
        @if (errorMessage) {
          <div class="whole-http-error-container">
            <mat-icon>error</mat-icon>
            {{ 'COMMON.ERROR.ERROR_VALIDATING_DATA' | translate }}
          </div>
        }
        @if (loadingUserProcess) {
          <div class="loading-wrapper" role="status" aria-live="polite">
            <span class="sr-only">
              {{ 'COMMON.LAYOUT.LOADING' | translate }}
            </span>
            <mat-spinner [diameter]="30" [attr.aria-hidden]="true"> </mat-spinner>
          </div>
        }
        <div
          matTooltip="{{ 'APPLICATION.PLEASE_VERIFY_DATA_IN_FORM' | translate }}"
          matTooltipClass="universalTooltip"
          [matTooltipDisabled]="!personalDataForm.invalid"
          class="save-and-proceed-button-wrapper">
          <span id="saveProceedHint" class="sr-only">
            {{ 'APPLICATION.PLEASE_VERIFY_DATA_IN_FORM' | translate }}
          </span>
          <button
            class="save-and-proceed-button"
            #saveAndProceedButton
            mat-flat-button
            aria-describedby="saveProceedHint"
            [disabled]="personalDataForm.invalid || !!errorMessage || loadingUserProcess"
            (click)="saveAndProceed()">
            {{ 'APPLICATION.SAVE_AND_PROCEED_TO_DOCUMENTS' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
}

<ng-template #loading>
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
